/** @format — Auto-scroll only when user is already near the bottom */

import { useCallback, useEffect, useRef } from "react";

const NEAR_BOTTOM_PX = 140;

export function useStickToBottomScroll(containerRef) {
  const stickRef = useRef(true);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return undefined;

    const onScroll = () => {
      const distance =
        el.scrollHeight - el.scrollTop - el.clientHeight;
      stickRef.current = distance <= NEAR_BOTTOM_PX;
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => el.removeEventListener("scroll", onScroll);
  }, [containerRef]);

  const scrollToBottom = useCallback(
    (force = false) => {
      const el = containerRef.current;
      if (!el) return;
      if (!force && !stickRef.current) return;
      el.scrollTop = el.scrollHeight;
    },
    [containerRef],
  );

  return { scrollToBottom, stickRef };
}
